import React from "react";
import "./About.css";

export default function NFTMEMBERSHIP() {
  return (
    <>
      <div className="wwa_title">NFT MEMBERSHIP</div>
      <div className="wwa_content">
        <div className="wwa_content_text">
          R/HOOD is the world's first on-chain creative neighbourhood, creating
          an off-chain community. R/HOOD is a creative curator and facilitator,
          supported by an NFT membership housed on the web3 open source
          infrastructure.
        </div>
        <div className="wwa_content_blank"></div>
      </div>
    </>
  );
}
